<template>
    <div class="ct-box box-sizing">
        <div class="ct-top"><el-divider><span class="ct-divider">天天短网址vip功能套餐对比</span></el-divider></div>
        <div style="text-align: center;padding:10px;font-size: 18px;color:#fff;background: #8dbf13;">
            <router-link to="/tabs/flowRecharge"><font color="#fff">购买任意访问包送VIP</font></router-link>
            </div>
        <div style="color:#f76a1a;font-size: 12px;background: #f5f5f5;padding:10px 10px; text-align: left;margin-top:30px;font-size: 16px;">请配合访问包使用，访问包低至0.01元/次<br>
          <div style="font-size: 12px;color:#999;">
            问题Q：我购买了vip或专属域名，为什么还需要购买访问包？<br>
            解释： vip是针对高级功能，专属域名是用户独立专享域名，访问包是访问的消耗，访问量越大，我们服务器成本越高，所以需要单独购买。<br>
              问题Q：如果没有访问包，会怎么样？<br>
              解释： 如果没有访问包，系统会跳转到广告。<br>
          </div>
        </div>
        <div class="pck-list clear-fix">

            <span class="pck-block tp pck-wd2 colorEven4"></span>
            <span class="pck-block bt pck-wd2 colorEven4"></span>
            <ol class="ovf" style="margin-left: 110px">
                <li>
                    <div class="ph pck-wd1 colorEven1">内容</div>
                    <div class="ph pck-wd2 colorEven2">游客</div>
                    <div class="ph pck-wd2 colorEven3">注册用户</div>
                    <div class="ph pck-wd2 colorEven3">普通vip</div>
                    <div class="ph pck-wd2 colorEven4">
                        <span class="ph-ft">年费 396元/年</span>
                        <router-link to="/tabs/vipRecharge" class="ph-link">立即升级</router-link>
                    </div>


                </li>
                <li>
                    <div class="pd pck-wd1 colorOdd1">添加短网址</div>
                    <div class="pd pck-wd2 colorOdd2"><i class="sure font">可以</i></div>
                    <div class="pd pck-wd2 colorOdd3"><i class="sure font">可以</i></div>
                    <div class="pd pck-wd2 colorOdd3"><i class="sure font">可以</i></div>
                    <div class="pd pck-wd2 colorOdd4"><i class="super-sure font">可以</i></div>
                </li>
                <li>
                    <div class="pd pck-wd1 colorEven1">有效性</div>
                    <div class="pd pck-wd2 colorEven2"><i class="sure font">限制</i></div>
                    <div class="pd pck-wd2 colorEven3"><i class="sure font">部分限制</i></div>
                    <div class="pd pck-wd2 colorEven3"><i class="sure font">可以</i></div>
                    <div class="pd pck-wd2 colorEven4"><i class="super-sure font">可以</i></div>
                </li>


                <li>
                    <div class="pd pck-wd1 colorEven1">单次批量转换</div>
                    <div class="pd pck-wd2 colorEven2"><i class="no-auth font">200条</i></div>
                    <div class="pd pck-wd2 colorEven3"><i class="sure font">500条</i></div>
                    <div class="pd pck-wd2 colorOdd3"><i class="sure font">500条</i></div>
                    <div class="pd pck-wd2 colorOdd4"><i class="super-sure font">1000条</i></div>
                </li>
                <li>
                    <div class="pd pck-wd1 colorEven1">数量限制</div>
                    <div class="pd pck-wd2 colorEven2"><i class="no-auth font">无权限</i></div>
                    <div class="pd pck-wd2 colorEven3"><i class="sure font">1万条</i></div>
                    <div class="pd pck-wd2 colorEven3"><i class="sure font">5万条</i></div>
                    <div class="pd pck-wd2 colorEven4"><i class="super-sure font">10万条</i></div>
                </li>
                <li>
                    <div class="pd pck-wd1 colorEven1">API接口转换</div>
                    <div class="pd pck-wd2 colorEven2"><i class="no-auth font">无权限</i></div>
                    <div class="pd pck-wd2 colorEven3"><i class="sure font">5000条</i></div>
                    <div class="pd pck-wd2 colorEven3"><i class="sure font">10000条</i></div>
                    <div class="pd pck-wd2 colorOdd4"><i class="super-sure font">10万条</i></div>
                </li>
                <li>
                    <div class="pd pck-wd1 colorEven1">API接口每分钟频率</div>
                    <div class="pd pck-wd2 colorEven2"><i class="no-auth font">无权限</i></div>
                    <div class="pd pck-wd2 colorEven3"><i class="sure font">50条</i></div>
                    <div class="pd pck-wd2 colorEven3"><i class="sure font">100条</i></div>
                    <div class="pd pck-wd2 colorEven4"><i class="super-sure font">150条</i></div>
                </li>
                <li>
                    <div class="pd pck-wd1 colorOdd1">访问明细统计</div>
                    <div class="pd pck-wd2 colorOdd2"><i class="no-auth font">无权限</i></div>
                    <div class="pd pck-wd2 colorOdd3"><i class="sure font">可以</i></div>
                    <div class="pd pck-wd2 colorOdd3"><i class="sure font">可以</i></div>
                    <div class="pd pck-wd2 colorOdd4"><i class="super-sure font">可以</i></div>
                </li>
                <li>
                    <div class="pd pck-wd1 colorEven1">查看简单分析报表</div>
                    <div class="pd pck-wd2 colorEven2"><i class="no-auth font">无权限</i></div>
                    <div class="pd pck-wd2 colorEven3"><i class="sure font">可以</i></div>
                    <div class="pd pck-wd2 colorEven3"><i class="sure font">可以</i></div>
                    <div class="pd pck-wd2 colorEven4"><i class="super-sure font">可以</i></div>
                </li>
                <li>
                    <div class="pd pck-wd1 colorOdd1">高级功能-多链接</div>
                    <div class="pd pck-wd2 colorOdd2"><i class="no-auth font">无权限</i></div>
                    <div class="pd pck-wd2 colorOdd3"><i class="sure font">无权限</i></div>
                    <div class="pd pck-wd2 colorEven3"><i class="sure font">可以</i></div>
                    <div class="pd pck-wd2 colorOdd4"><i class="super-sure font">可以</i></div>
                </li>
                <li>
                    <div class="pd pck-wd1 colorOdd1">淘宝短链接</div>
                    <div class="pd pck-wd2 colorOdd2"><i class="no-auth font">无权限</i></div>
                    <div class="pd pck-wd2 colorOdd3"><i class="sure font">限制</i></div>
                    <div class="pd pck-wd2 colorEven3"><i class="sure font">可以</i></div>
                    <div class="pd pck-wd2 colorEven4"><i class="super-sure font">可以</i></div>
                </li>
                <li>
                    <div class="pd pck-wd1 colorOdd1">智能策略-PC识别</div>
                    <div class="pd pck-wd2 colorOdd2"><i class="no-auth font">无权限</i></div>
                    <div class="pd pck-wd2 colorOdd3"><i class="sure font">可以</i></div>
                    <div class="pd pck-wd2 colorEven3"><i class="sure font">可以</i></div>
                    <div class="pd pck-wd2 colorOdd4"><i class="super-sure font">可以</i></div>
                </li>
                <li>
                    <div class="pd pck-wd1 colorEven1">智能策略-移动设备识别</div>
                    <div class="pd pck-wd2 colorEven2"><i class="no-auth font">无权限</i></div>
                    <div class="pd pck-wd2 colorEven3"><i class="sure font">可以</i></div>
                    <div class="pd pck-wd2 colorEven3"><i class="sure font">可以</i></div>
                    <div class="pd pck-wd2 colorEven4"><i class="super-sure font">可以</i></div>
                </li>
                <li>
                    <div class="pd pck-wd1 colorOdd1">智能策略-地理位置策略</div>
                    <div class="pd pck-wd2 colorOdd2"><i class="no-auth font">无权限</i></div>
                    <div class="pd pck-wd2 colorOdd3"><i class="sure font">可以</i></div>
                    <div class="pd pck-wd2 colorEven3"><i class="sure font">可以</i></div>
                    <div class="pd pck-wd2 colorOdd4"><i class="super-sure font">可以</i></div>
                </li>
                <li>
                    <div class="pd pck-wd1 colorEven1">智能策略-微信浏览器识别</div>
                    <div class="pd pck-wd2 colorEven2"><i class="no-auth font">无权限</i></div>
                    <div class="pd pck-wd2 colorEven3"><i class="no-auth font">无权限</i></div>
                    <div class="pd pck-wd2 colorEven3"><i class="sure font">可以</i></div>
                    <div class="pd pck-wd2 colorEven4"><i class="super-sure font">可以</i></div>
                </li>
                <li>
                    <div class="pd pck-wd1 colorOdd1">智能策略-微博内嵌页面识别</div>
                    <div class="pd pck-wd2 colorOdd2"><i class="no-auth font">无权限</i></div>
                    <div class="pd pck-wd2 colorOdd3"><i class="no-auth font">无权限</i></div>
                    <div class="pd pck-wd2 colorEven3"><i class="sure font">可以</i></div>
                    <div class="pd pck-wd2 colorOdd4"><i class="super-sure font">可以</i></div>
                </li>
                <li>
                    <div class="pd pck-wd1 colorEven1">查看具体分析报表</div>
                    <div class="pd pck-wd2 colorEven2"><i class="no-auth font">无权限</i></div>
                    <div class="pd pck-wd2 colorEven3"><i class="no-auth font">无权限</i></div>
                    <div class="pd pck-wd2 colorEven3"><i class="sure font">可以</i></div>
                    <div class="pd pck-wd2 colorEven4"><i class="super-sure font">可以</i></div>
                </li>
                <li>
                    <div class="pd pck-wd1 colorOdd1">管理短网址</div>
                    <div class="pd pck-wd2 colorOdd2"><i class="no-auth font">无权限</i></div>
                    <div class="pd pck-wd2 colorOdd3"><i class="no-auth font">无权限</i></div>
                    <div class="pd pck-wd2 colorEven3"><i class="sure font">可以</i></div>
                    <div class="pd pck-wd2 colorOdd4"><i class="super-sure font">可以</i></div>
                </li>
                <li>
                    <div class="pd pck-wd1 colorEven1">设置短网址访问密码</div>
                    <div class="pd pck-wd2 colorEven2"><i class="no-auth font">无权限</i></div>
                    <div class="pd pck-wd2 colorEven3"><i class="no-auth font">无权限</i></div>
                    <div class="pd pck-wd2 colorEven3"><i class="sure font">可以</i></div>
                    <div class="pd pck-wd2 colorEven4"><i class="super-sure font">可以</i></div>
                </li>
                <li>
                    <div class="pd pck-wd1 colorOdd1">修改短网址指向</div>
                    <div class="pd pck-wd2 colorOdd2"><i class="no-auth font">无权限</i></div>
                    <div class="pd pck-wd2 colorOdd3"><i class="no-auth font">无权限</i></div>
                    <div class="pd pck-wd2 colorEven3"><i class="sure font">可以</i></div>
                    <div class="pd pck-wd2 colorOdd4"><i class="super-sure font">可以</i></div>
                </li>
                <li>
                    <div class="pd pck-wd1 colorEven1">高级功能-不同地区指向网址</div>
                    <div class="pd pck-wd2 colorEven2"><i class="no-auth font">无权限</i></div>
                    <div class="pd pck-wd2 colorEven3"><i class="no-auth font">无权限</i></div>
                    <div class="pd pck-wd2 colorEven3"><i class="sure font">可以</i></div>
                    <div class="pd pck-wd2 colorEven4"><i class="super-sure font">可以</i></div>
                </li>
                <li>
                    <div class="pd pck-wd1 colorOdd1">高级功能-不同设备指向网址</div>
                    <div class="pd pck-wd2 colorOdd2"><i class="no-auth font">无权限</i></div>
                    <div class="pd pck-wd2 colorOdd3"><i class="no-auth font">无权限</i></div>
                    <div class="pd pck-wd2 colorEven3"><i class="sure font">可以</i></div>
                    <div class="pd pck-wd2 colorOdd4"><i class="super-sure font">可以</i></div>
                </li>
            </ol>


        </div>
        <div style="padding: 50px 0 100px 110px;">如需单独定制，请咨询客服：微信dwz-kf QQ：3683390325</div>
    </div>

</template>

<script>
    export default {
        name: "Contrast",
    }
</script>

<style scoped>
    .ct-box{
        width: 100%;
        height: auto;
        padding: 20px;
    }
    .ct-box .ct-divider{
        font-size: 24px;
        font-weight: 200;
        letter-spacing: 5px;
    }
    .ct-top{
        width: 100%;
        height: 25px;
    }
    .ovf{ overflow: hidden;}
    .pck-wd1{width: 251px;}
    .pck-wd2{width: 165px;}
    .colorEven1{background-color: #f0f9ff;}
    .colorOdd1{background-color: #f3faff;}
    .colorEven2{background-color: #e5f5ff;}
    .colorOdd2{background-color: #eaf7ff;}
    .colorEven3{background-color: #ccebff;}
    .colorOdd3{background-color: #d6efff;}
    .colorEven4{background-color: #008df2;}
    .colorOdd4{background-color: #33a4f5;}
    .pck-list{position: relative;margin-top: 60px;margin-bottom: 20px;}
    .pck-list .pck-block{position: absolute;right:0;height: 20px;display: block;}
    .pck-list .tp{top:-20px;right:119px;border-top-left-radius:10px;border-top-right-radius:10px;}
    .pck-list .bt{bottom:-20px;right:119px;border-bottom-left-radius:10px;border-bottom-right-radius:10px;}
    .pck-list ol{border-bottom-left-radius: 10px;border-top-left-radius: 10px;}
    .pck-list li{*display: block;overflow: hidden;white-space: nowrap;}
    .pck-list .ph{height: 100px;line-height: 100px;float: left;font-size: 20px;font-weight: 100;text-align: center;letter-spacing: 2px;}
    .pck-list .ph .ph-ft{font-size: 20px;color:#fff;font-weight: bold;display: block;line-height: normal;margin-top: 2px;letter-spacing: 0;}
    .pck-list .ph .ph-link{width: 140px;height: 34px;line-height: 34px;background-color: #fff;border-radius: 2rem;margin: 15px auto 0 auto;font-size: 16px;color: #008df2;cursor: pointer;display: block;letter-spacing: 0;}
    .pck-list .pd{height: 45px;line-height: 45px;float: left;text-align: center;color: #666;}
    .pck-list .contrast{height: 100%;display: block;}
    .pck-list .pd .font{padding-left: 35px;color: #008df2;font-style: normal;}
    .pck-list .pd .sure{background: url("../../assets/images/icon_dg1.png") no-repeat left center;}
    .pck-list .pd .super-sure{background: url("../../assets/images/icon_dg2.png") no-repeat left center;color: #fff;font-weight: bold;font-size: 16px;}
    .pck-list .pd .no-auth{background: url("../../assets/images/icon_dx1.png") no-repeat left center;color: #999;margin-left: 14px;}
</style>
